module.exports = __webpack_public_path__ + "img/timers-on.e119d9af.jpg";